/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Provider } from '@angular/core';
import { AbstractControl, ControlContainer, FormArray, FormGroup, FormGroupDirective } from '@angular/forms';

export const FormProvider: Provider = {
  provide: ControlContainer,
  useExisting: FormGroupDirective,
};

export function patchFormArray(formArray: FormArray, values: unknown[], createFn: (value: unknown) => FormGroup): void {
  formArray.clear();
  values.forEach((value) => {
    formArray.push(createFn(value));
  });
}

export function swapFormArrayControls(formArray: FormArray, indexA: number, indexB: number): void {
  if (indexA === indexB) return;
  const controlA: AbstractControl = formArray.at(indexA);
  const controlB: AbstractControl = formArray.at(indexB);
  formArray.setControl(indexA, controlB);
  formArray.setControl(indexB, controlA);
}
